import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    container: {
        position: 'fixed',
        top: (theme: Theme) => theme.size.pxValue(theme.size.navbarHeight),
        bottom: '0',
        right: 0,
        zIndex: (theme: Theme) => theme.zIndex.drawer - 1,
        '.hierarchy-resize-container': {
            display: 'flex',
            flexDirection: 'column',
            height: 1,
            overflow: 'hidden',
            borderLeft: '1px solid',
            borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.08)),
            boxShadow: (theme: Theme) => `0px 4px 16px 0px ${alpha(theme.palette.text.primary, 0.16)}`,
            backgroundColor: 'background.default',
        },
    },
    resizeHandler: {
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        width: '100%',
        flexShrink: 0,
        borderLeft: '1px solid',
        borderColor: 'transparent',
        transition: 'all 0s ease-in-out .1s',
        '&:hover, .resizing-active &': {
            borderColor: (theme: Theme) => theme.palette.primary.main,
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
        },
    },
    resizeStyle: {
        left: 0,
        height: '100%',
        width: '7px',
        zIndex: 1,
        cursor: 'col-resize',
    },
};
